export default "__VITE_ASSET__C64NBG$7__"